module.exports = new __parcel__URL__("paladin.45269b78.png").toString();